import styled from 'styled-components'

const textPrimary = p => p.theme.colors.text.primaryText
const textSecondary = p => p.theme.colors.text.secondaryText
const brandBlue = p => p.theme.colors.brand.blueOmint
const branDarkdBlue = p => p.theme.colors.brand.blueDark

export const ModalContainer = styled.div`
	background-color: ${p => p.theme.colors.brand.white};
	display: flex;
	flex: 1;
	align-items: center;
	border-radius: 12px;
	padding: 24px;
	padding-top: ${({ pt }) => pt ? `${pt}px` : '24px'};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		align-items: stretch;
		justify-content: center;
			height: ${({ isFullHeight }) => (isFullHeight ? '100%' : 'none')};

	}
`

export const MessageContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ gap }) => (typeof gap === 'number' ? `${gap}px` : gap || '10px')};
	align-items: center;
	width: 100%;
	padding: ${({ padding }) => padding ? `${padding}px` : '0'};
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: ${({ isFullHeight }) => (isFullHeight ? 'flex-start' : 'space-between')};
		font-size: 14px;
		max-width: 398px;
		padding: 10px 10px 10px 10px;
	}
`
export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: ${({ isFullHeight }) => (isFullHeight ? 'center' : 'flex-start')};
	gap: ${({ gap }) => (typeof gap === 'number' ? `${gap}px` : gap || '32px')};
	width: 100%;
	max-width: ${({ widthDesktop }) => widthDesktop || '430px'};
	${({ isFullHeight }) => isFullHeight && `
		flex: 1;
		min-height: 0;
	`}
`
export const ButtonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
	}
`
